import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { UploadDesignService } from '@app/feature/store-admin/services/uploadDesign/uploadDesign.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
@Component({
  selector: 'app-upload-design',
  templateUrl: './upload-design.component.html',
  styleUrls: ['./upload-design.component.css']
})
export class UploadDesignComponent implements OnInit {
  imageSrc !: any;
  uploadDesignForm: FormGroup;
  isShowPreview = true;
  selectedFileName: string = '';
  isUploading: boolean = false;
  uploadProgress: number = 0;
  uploadComplete: boolean = false;

  constructor(public dialogRef: MatDialogRef<UploadDesignComponent>, private formBuilder: FormBuilder,
    private uploadDesignService: UploadDesignService, private notification: NotificationService, private loader: LoaderService, private errorhandlerService: ErrorhandlerService) {
    this.uploadDesignForm = this.formBuilder.group({
      UploadedBase64FileUrl : [''],
      DesignName: ['', Validators.compose([Validators.required])],
      DesignDescription: [''],
      DesignPrice: ['', Validators.compose([Validators.required, Validators.pattern('^[0-9]{1,8}(\.[0-9]+)?$')])],
      CreatedBy : [localStorage.getItem('userId')],
      imageInputValidationField: ['', Validators.required]
    });
  }

  ngOnInit() {
  }

  get f() { return this.uploadDesignForm.controls; }

  onclose(): void {
    this.dialogRef.afterClosed().subscribe(result => {
          });
    this.isShowPreview = true;
  }

  /**Function to uplaod design file to db */
  UploadDesign(form: FormGroup) {
    this.loader.show();
    this.uploadDesignService.uploadDesign(this.uploadDesignForm.value).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.notification.success(res.Message, 'UploadDesign');
        this.dialogRef.close();
        this.loader.hide();
      } else if (res.StatusCode === 500) {
        this.notification.error('An error occured', 'Error');
        this.loader.hide();
      } else {
        this.loader.hide();
      }
      this.dialogRef.close();
       }, (err: any) => {
        // this.notification.error('An error occured', 'Error');
        this.errorhandlerService.handleError(err);
        this.loader.hide();
    });
  }

  onSelectFile(event: { target: { files: any[]; }; }): void {
      const reader = new FileReader();

      if (event.target.files && event.target.files.length) {
        const file = event.target.files[0];

        // Validate file type — PNG, JPG, PDF and SVG are supported. UX gate only: this component
        // posts a data: URI to /Design/UploadDesign, where CreateUploadDesignCommandHandler is the
        // real gate (allow-list + byte sniffing + SVG sanitization before it reaches the database).
        const allowedExtensions = ['.png', '.jpg', '.jpeg', '.pdf', '.svg'];
        const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
          this.notification.error('File type not supported. Please upload PNG, JPG, PDF, or SVG files.', 'Error');
          return;
        }

        this.selectedFileName = file.name;

        // Reset states
        this.uploadComplete = false;
        this.uploadProgress = 0;
        this.isUploading = true;

        reader.readAsDataURL(file);

        reader.onload = () => {
          const b = this.uploadDesignForm.get('UploadedBase64FileUrl');
          if (b) {
            b.patchValue(reader.result);
          }

          this.uploadDesignForm.controls['imageInputValidationField'].setValue(event.target.files ?
            event.target.files.length : ''); // <-- Set Value for Validation

          this.imageSrc = reader.result;
          this.isShowPreview = false;

          // Simulate upload progress
          this.simulateUploadProgress();
        };
      }
    }

  /** Simulate upload progress for visual feedback */
  simulateUploadProgress(): void {
    const interval = setInterval(() => {
      if (this.uploadProgress < 100) {
        this.uploadProgress += 10;
      } else {
        clearInterval(interval);
        this.isUploading = false;
        this.uploadComplete = true;
      }
    }, 100);
  }

  /** Remove selected file and reset to initial state */
  removeFile(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.imageSrc = null;
    this.selectedFileName = '';
    this.isShowPreview = true;
    this.isUploading = false;
    this.uploadProgress = 0;
    this.uploadComplete = false;

    // Reset form fields
    this.uploadDesignForm.get('UploadedBase64FileUrl')?.patchValue('');
    this.uploadDesignForm.controls['imageInputValidationField'].setValue('');

    // Reset the file input
    const fileInput = document.getElementById('file-upload') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
}
